import { useState } from 'react';
import styles from './index.module.sass';
import arrowDown from '@/modules/mixing/images/arrow-down.svg';
import { BestPricesResponseItem } from '@/modules/mixing/ts/buyers-prices.types';
import { SleeveData } from './components/sleeve-data/index.component';
import { SleevesTableHead } from './components/table-head';
import {
  $expandedStoresArr,
  addExpandedStore,
  BestPriceWarehouseItem,
} from '@/modules/mixing/store/analytical-mixing.store';
import { useStore } from 'effector-react';

export const WarehouseSection = ({
  data,
  tooltipData,
  setTooltipData,
  expandedByDefault,
}: {
  data: BestPriceWarehouseItem;
  tooltipData: any;
  setTooltipData: (args: any) => void;
  expandedByDefault?: boolean;
}) => {
  const expandedStoresArr = useStore($expandedStoresArr);

  const expanded = expandedStoresArr.includes(data.id);
  return (
    <div className={styles.root}>
      <div
        className={styles.topArea}
        onClick={() => addExpandedStore({ id: data.id, expanded: !expanded })}
      >
        <div className={styles.root__col}>
          <img
            src={arrowDown}
            style={{
              transition: '.15s',
              transform: !expanded ? 'rotate(180deg)' : 'none',
            }}
          />
          <span className={styles.warehouseName}>{data?.name}</span>
        </div>
        <div className={styles.root__col}>
          <div className={styles.indicator}>
            <span className={styles.col__label}>общий вес пшеницы на складе:</span>
            <span className={styles.col__val}>
              {data?.weight?.toLocaleString('RU-ru')} т
            </span>
          </div>
          <div className={styles.indicator}>
            <span className={styles.col__label}>
              стоимость пшеницы по лучшей цене покупателей:
            </span>
            <span className={styles.col__val}>
              {+data?.price > 0 ? data?.price?.toLocaleString('RU-ru') + ' ₽' : 'н/д'}
            </span>
          </div>
        </div>
      </div>

      <div className={styles.mobileScrollable}>
        <div
          className={styles.expandableContent}
          style={{ display: expanded ? 'flex' : 'none' }}
        >
          <SleevesTableHead />
          {data?.bags?.length > 0 ? (
            data?.bags?.map((item, i) => (
              <SleeveData
                odd={(i + 1) % 2 === 0}
                data={item}
                key={i}
                tooltipData={tooltipData}
                setTooltipData={setTooltipData}
                status={item.status}
                warehouse_id={data.id}
              />
            ))
          ) : (
            <span className={styles.empty}>Рукавов не найдено!</span>
          )}
        </div>
      </div>
    </div>
  );
};
